module.exports = __webpack_public_path__ + "files/8dd2a66a346c918b5f5dd36806580bcd.png";